<template>
    <div class="tab-inner-content">
        <ul class="extensions-list-info menu-extensions-add">
            <li class="extension-info-list-item">
                <div class="extension-info">
                    <h3 class="extension-title-info">Safe Browsing</h3>
                    <p class="description-extension">Get real time alerts when you are on a
                        dangerous
                        site</p>
                </div>
                <div class="extension-action-wrapper">
                    <a href="#" v-if="(!this.isInstalledByType('safe'))" @click.prevent="installExtension('safe')"
                       class="btn default-btn">Add to {{userAgent.browser.name}}</a>
                    <a href="#" v-else class="btn checked-btn"
                       @click.prevent="activeContentChange('safe_browsing','safe')">Settings</a>
                </div>
            </li>
            <li class="extension-info-list-item">
                <div class="extension-info">
                    <h3 class="extension-title-info">Speed test</h3>
                    <p class="description-extension">Run a full speed test on your browser</p>
                </div>
                <div class="extension-action-wrapper" @click.prevent="activeContentChange('speed_test','speed_test')"
                     data-change-tab="speed-tab">
                    <a href="#" class="btn checked-btn">Check</a>
                </div>
            </li>
            <li class="extension-info-list-item">
                <div class="extension-info">
                    <h3 class="extension-title-info">Data Manager</h3>
                    <p class="description-extension">Manage the data that is being collected on
                        you </p>
                </div>
                <div class="extension-action-wrapper">
                    <a href="#" v-if="(!this.isInstalledByType('data'))" @click.prevent="installExtension('data')"
                       class="btn default-btn">Add to {{userAgent.browser.name}}</a>
                    <a href="#" @click.prevent="activeContentChange('data_manager','data')" v-else
                       class="btn checked-btn">Settings</a>

                </div>
            </li>
            <li class="extension-info-list-item">
                <div class="extension-info">
                    <h3 class="extension-title-info">Private Browsing</h3>
                    <p class="description-extension">Clear personal tracking data in real time</p>
                </div>
                <div class="extension-action-wrapper">
                    <a href="#" v-if="(!this.isInstalledByType('private'))"
                       @click.prevent="installExtension('private')" class="btn default-btn">Add to
                        {{userAgent.browser.name}}</a>
                    <a href="#" v-else class="btn checked-btn"
                       @click.prevent="activeContentChange('private_browsing','private')">Settings</a>
                </div>
            </li>
            <li class="extension-info-list-item">
                <div class="extension-info">
                    <h3 class="extension-title-info">About us</h3>
                    <p class="description-extension">Safety , privacy , and online protection</p>
                </div>
                <div class="extension-action-wrapper">
                    <a href="#" @click.prevent="activeContentChange('about_us','about_us')" class="btn default-btn">Learn more</a>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "contentMain",
        props: ['userAgent', 'extensions'],
        methods: {
            activeContentChange: function (content, type) {
                this.$parent.activeContentChange(content, type);
            },
            isInstalledByType: function (extensionsType) {
                return this.$parent.isInstalledByType(extensionsType);
            },
            installExtension: function (extensionsType) {
                return this.$parent.installExtension(extensionsType);
            }
        }
    }
</script>

<style scoped>
    .tab-inner-content {
        transition: all .3s ease-in;
        height: 100%;
        width: 100%;
    }

    .extension-info-list-item {
        padding: 29px 40px 25px 40px;
        list-style-type: none;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        border-bottom: 1px solid #e1e1e1;
    }

    .extension-info {
        padding-right: 10px;
        max-width: calc(100% - 140px);
    }

    .extension-title-info {
        margin-bottom: 10px;
        font-size: 18px;
    }

    .description-extension {
        font-size: 14px;
    }

    .extension-action-wrapper {
        min-width: 140px;
        text-align: center;
    }

    /*
    *****************************
        online-tools
    *****************************
    */

    .onlinetools .extension-title-info {
        color: #3C557E;
    }

    .onlinetools .description-extension {
        color: #3C557E;
    }

</style>